import React, { Fragment } from 'react';
import { ArticleCard } from './ArticleCard';
import { AdPlaceholder } from './AdPlaceholder';
export function HeroSection() {
  const sideArticles = [{
    title: 'Smithfield Foods taps Pabst for beer brat launch',
    category: 'Companies',
    date: '04.07.2026',
    author: 'Rachael Oatman',
    imageUrl: 'https://placehold.co/400x300/e2e8f0/475569?text=Beer+Brat'
  }, {
    title: "McDonald's, suppliers work with NFWF on grassland conservation grants",
    category: 'Trends',
    date: '04.07.2026',
    author: 'Ryan McCarthy',
    imageUrl: 'https://placehold.co/400x300/e2e8f0/475569?text=Cattle'
  }, {
    title: 'FSIS retracts public health alert tied to Dino nuggets',
    category: 'Agencies',
    date: '04.07.2026',
    author: 'Bob Sims',
    imageUrl: 'https://placehold.co/400x300/e2e8f0/475569?text=Dino+Nuggets'
  }];
  return <section className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-12" data-id="element-88" data-mp="3ka3297lyiuuk">
      {/* Left Column - Main Feature */}
      <div className="lg:col-span-7 xl:col-span-8" data-id="element-89" data-mp="2ffs3hlmcdmxu">
        <a href="/article" className="group cursor-pointer block" data-id="element-90" data-mp="2begjpwq5fvxk">
          <img src="https://placehold.co/800x500/e2e8f0/475569?text=Bacon+Packaging" alt="Bacon packaging" className="w-full h-auto object-cover mb-4" data-id="element-91" data-mp="2bc3vj1tsspc2" />
          <h2 className="font-serif text-3xl md:text-[2.5rem] leading-tight text-gray-900 group-hover:text-[#002f5f] transition-colors mb-3" data-id="element-92" data-mp="2kcs77pvpydls">
            Bacon packaging advances target throughput, consistency
          </h2>
          <div className="text-[15px] mb-4" data-id="element-93" data-mp="384pkllethdp0">
            <span className="text-[#002f5f] hover:underline" data-id="element-94" data-mp="383nzsp801cu3">Operations</span>
            <span className="mx-3 text-gray-500" data-id="element-95" data-mp="3365ynl0841wn">03.31.2026</span>
            <span className="text-gray-500" data-id="element-96" data-mp="1dpwozmdxomx2">
              By{' '}
              <span className="text-[#002f5f] hover:underline" data-id="element-97" data-mp="1ds965xbvat92">
                Keith Loria
              </span>
            </span>
          </div>
          <p className="text-gray-800 text-lg" data-id="element-98" data-mp="38u4j0xyqp68r">
            As bacon processing innovations evolve, packaging technology races
            ahead.
          </p>
        </a>
      </div>

      {/* Right Column - Side Articles & Ad */}
      <div className="lg:col-span-5 xl:col-span-4 flex flex-col" data-id="element-99" data-mp="3ipxsu9l2qlmu">
        <div className="flex flex-col gap-6 mb-8 mt-8 lg:mt-0" data-id="element-100" data-mp="3mtclbzq78uh6">
          {sideArticles.map((article, index) => <Fragment key={index} data-id="element-101" data-mp="3rr5mufgk50b4" data-mpi={index}>
              <ArticleCard {...article} data-id="element-102" data-mp="3rq2z2gej7dzf" />
              {index < sideArticles.length - 1 && <div className="h-px bg-gray-200 w-full" data-id="element-103" data-mp="jt80735cyyd"></div>}
            </Fragment>)}
        </div>

        {/* Square Ad Placeholder */}
        <div className="mt-auto border-t border-gray-200 pt-8" data-id="element-104" data-mp="aanunckb20kc">
          <AdPlaceholder height="h-[250px] md:h-[300px]" text="EXPLORE LEAD-GEN TACTICS for 2026 (Ad)" className="bg-[#d9534f] text-white text-xl font-bold text-center p-6 w-full" data-id="element-105" data-mp="edkh5ecyugtk" />
        </div>
      </div>
    </section>;
}